import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../components/Loader';
import { getGenaiJobDetails } from '../actions/genaiActions';

const STEP_TO_PATH = {
    D_approve_story: 'review-story',
    F_approve_cover: 'review-pages',  // old-flow jobs: redirect to unified illustrations review
    H_approve_pages: 'review-pages',
    J_approve_final: 'final-review',
};

function GenaiJobRedirectScreen() {
    const { jobId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const genaiJobDetails = useSelector(state => state.genaiJobDetails);
    const { job, error } = genaiJobDetails;

    useEffect(() => {
        dispatch(getGenaiJobDetails(jobId));
    }, [dispatch, jobId]);

    useEffect(() => {
        if (job) {
            const subPath = STEP_TO_PATH[job.current_step] || 'final-review';
            navigate(`/genai/job/${jobId}/${subPath}`, { replace: true });
        }
        if (error) {
            navigate('/genai/jobs', { replace: true });
        }
    }, [job, error, jobId, navigate]);

    return <Loader />;
}

export default GenaiJobRedirectScreen;
